import { render } from "./Home.vue?vue&type=template&id=48ed4659&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=48ed4659&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48ed4659"

export default script